import { createBrowserRouter } from 'react-router';

import { AppShell } from '../layout/AppShell';
import { GuestOnly, HomeRedirect, RequireAuth, RequireGlobalAdmin } from './guards';
import { OrganizationGuard } from './OrganizationGuard';
import { organizationRoutes } from './organization-routes';
import { RouteError } from './RouteError';

/** Pages load on demand: the first screen does not carry the warehouse or rentals code. */
export const router = createBrowserRouter([
  {
    errorElement: <RouteError />,
    children: [
      {
        element: <GuestOnly />,
        children: [
          {
            path: '/login',
            lazy: async () => ({ Component: (await import('@/pages/login')).LoginPage }),
          },
        ],
      },
      {
        element: <RequireAuth />,
        children: [
          {
            element: <AppShell />,
            children: [
              { index: true, element: <HomeRedirect /> },
              {
                path: 'organizations',
                lazy: async () => ({
                  Component: (await import('@/pages/organizations')).OrganizationsPage,
                }),
              },
              {
                path: 'profile',
                lazy: async () => ({ Component: (await import('@/pages/profile')).ProfilePage }),
              },
              {
                path: 'admin',
                element: <RequireGlobalAdmin />,
                children: [
                  {
                    path: 'users',
                    lazy: async () => ({
                      Component: (await import('@/pages/admin-users')).AdminUsersPage,
                    }),
                  },
                  {
                    path: 'organizations',
                    lazy: async () => ({
                      Component: (await import('@/pages/admin-organizations'))
                        .AdminOrganizationsPage,
                    }),
                  },
                ],
              },
              {
                path: 'o/:organizationId',
                element: <OrganizationGuard />,
                children: organizationRoutes,
              },
              {
                path: '*',
                lazy: async () => ({ Component: (await import('@/pages/not-found')).NotFoundPage }),
              },
            ],
          },
        ],
      },
    ],
  },
]);
